import styled, { css } from 'styled-components';

export const PaneMeasurementsCanvas = styled.div<{ visible: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  ${({ visible }) => (visible
    ? css`background-color: white;`
    : css`visibility: hidden;`
  )}
`;
